import { useDeliveryApi } from 'infrastructure/api';
import {
  FinalizeProjectReviewData,
  ProjectReviewPeriod,
  ProjectReviewPeriodInfo,
  ProjectReviewResult,
  SummaryReviewDetails,
} from './types';
import { getFinalizeProjectReviewPayload } from './projectReviewPayload';

const useProjectReviewService = () => {
  const { sendGetRequest, sendPostRequest } = useDeliveryApi();

  const getLatestProjectReview = async (projectId: string): Promise<ProjectReviewPeriodInfo> => {
    const response = await sendGetRequest(`/projects/${projectId}/summary-review/period`);
    return response.json();
  };

  const getProjectReviewById = async (reviewId: string): Promise<SummaryReviewDetails> => {
    const response = await sendGetRequest(`/projects/summary-review/${reviewId}`);
    return response.json();
  };

  const startProjectReview = async (projectId: string, period: ProjectReviewPeriod): Promise<ProjectReviewResult> => {
    const queryParams = new URLSearchParams({ from: period.from, to: period.to });
    const response = await sendGetRequest(`/projects/${projectId}/summary-report?${queryParams.toString()}`);
    const result = await response.json();

    return { ...result, periodMode: period.periodMode };
  };

  const finalizeProjectReview = async (
    projectId: string,
    review: ProjectReviewResult,
    data: FinalizeProjectReviewData,
  ): Promise<void> => {
    await sendPostRequest(
      `/projects/${projectId}/summary-review`,
      getFinalizeProjectReviewPayload(review, data.note, data.comments),
    );
  };

  return {
    finalizeProjectReview,
    getLatestProjectReview,
    getProjectReviewById,
    startProjectReview,
  };
};

export default useProjectReviewService;
